/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo does not know about any of your conversations yet. Add one yourself, or connect your calendar so they appear here by themselves." |
*
* @param {Agenda_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_empty_body = /** @type {((inputs?: Agenda_Empty_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Empty_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kent nog geen enkel gesprek van je. Voeg er zelf een toe, of koppel je agenda zodat ze hier vanzelf verschijnen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo ne connaît encore aucune de vos conversations. Ajoutez-en une vous-même, ou connectez votre agenda pour qu’elles apparaissent ici toutes seules.")
	return /** @type {LocalizedString} */ ("Wundo does not know about any of your conversations yet. Add one yourself, or connect your calendar so they appear here by themselves.")
});